import { computed, type MaybeRefOrGetter, toValue } from "vue";
import type { TripRouteStop, TripStop } from "src/types/trip";
import { OrderStopType } from "@/constants/order";

export type FreightOrdinals = { pickupOrdinal: number; freightOrdinal: number };

export function useFreightOrdinals(tripStops: MaybeRefOrGetter<(TripStop | TripRouteStop)[]>) {
  const pickupStops = computed<(TripStop | TripRouteStop)[]>(() => {
    return [...toValue(tripStops)]
      .filter((s) => s.type === OrderStopType.pickup)
      .sort((a, b) => a.position - b.position);
  });

  function getFreightOrdinals(freightId: string | undefined): FreightOrdinals | null {
    if (!freightId) {
      return null;
    }

    const pickupIndex = pickupStops.value.findIndex((p) => p.freights?.includes(freightId));
    if (pickupIndex === -1) {
      return null;
    }

    const pickup = pickupStops.value[pickupIndex];
    const freightIndex = pickup.freights.indexOf(freightId);

    if (freightIndex === -1) {
      return null;
    }

    return { pickupOrdinal: pickupIndex + 1, freightOrdinal: freightIndex + 1 };
  }

  function getFreightOrdinalLabel(freightId: string | undefined): string | null {
    const ordinals = getFreightOrdinals(freightId);
    return ordinals ? `${ordinals.pickupOrdinal}-${ordinals.freightOrdinal}` : null;
  }

  return {
    getFreightOrdinalLabel,
  };
}
